export default angular
  .module("ModifyAssignedToCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("ModifyAssignedToController", [
    "$scope",
    "messageItemId",
    "assignedId",
    "$state",
    "$modalInstance",
    "$modal",
    "$stateParams",
    "$http",
    "$rootScope",
    "$translate",
    "Scripts",
    "System",
    function (
      $scope,
      messageItemId,
      assignedId,
      $state,
      $modalInstance,
      $modal,
      $stateParams,
      $http,
      $rootScope,
      $translate,
      Scripts,
      System,
    ) {
      System.loadUsers((data) => {
        $scope.users = data;
        $scope.selectedUser = data
          .filter(el => el.ID === assignedId)[0] || {};
      });
      $scope.sortUsers = [];
      $scope.sortUsers.column = "USER_FULL_NAME";
      $scope.sortUsers.direction = false;
      const receiver = {
        MESSAGE_ID: messageItemId || null,
        TO_USER_ID: assignedId || null,
        ASSIGNED: messageItemId ? 1 : null,
      };

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = (column) => {
        if ($scope.sortUsers.column === column) {
          $scope.sortUsers.direction = !$scope.sortUsers.direction;
        } else {
          $scope.sortUsers.column = column;
          $scope.sortUsers.direction = false;
        }
      };

      // apply isNewMessageItem
      $scope.setAssignedTo = (user) => {
        receiver.TO_USER_ID = user.ID;
        receiver.ASSIGNED = 1;
        receiver.USER_FULL_NAME = user.USER_FULL_NAME;
      };

      $scope.ok = () => $modalInstance.close({ action: "save", payload: { ...receiver } });
      $scope.cancel = () => $modalInstance.dismiss({ action: "cancel", payload: {} });
    },
  ]);
